import type { StripeSetupIntent } from "@/models/subscription";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export async function upsertSetupIntent(): Promise<
  APIResponse<StripeSetupIntent>
> {
  try {
    const resp = await callApi<StripeSetupIntent>(`${API_BASE}/setup_intents`, {
      method: "POST",
    });
    return resp;
  } catch (e: unknown) {
    return e as APIResponse<StripeSetupIntent>;
  }
}
